import {
  apiClient,
  BulkPostPaymentSettingsCalculatorRequest,
  PaymentSettingsCalculations,
  PaymentSettingsCalculatorRequestParams,
} from '@melio/javascript-sdk';
import { getCentsFromDollars } from '@melio/platform-utils';

const preparePaymentSettingsParams = (params: BulkPostPaymentSettingsCalculatorRequest) =>
  params.map((param) => ({
    ...param,
    amountToPay: getCentsFromDollars(param.amountToPay),
    invoicesData: param.invoicesData.map((invoice) => ({
      ...invoice,
      amount: getCentsFromDollars(invoice.amount),
    })),
  }));

import { useCollectionApi, UseCollectionApiProps } from '../../core';
import { PaymentSettingsCollection } from './types';

export type UsePaymentSettingsProps = UseCollectionApiProps<PaymentSettingsCalculations> &
  PaymentSettingsCalculatorRequestParams & {
    params: BulkPostPaymentSettingsCalculatorRequest;
  };

export const usePaymentSettings = ({
  params,
  fillWithDefaults = false,
  ...props
}: UsePaymentSettingsProps): PaymentSettingsCollection => {
  const client = apiClient.paymentSettings();

  const query = useCollectionApi<PaymentSettingsCalculations, BulkPostPaymentSettingsCalculatorRequest>({
    ...props,
    queryKey: ['payment-settings', params],
    queryFn: () =>
      client.getPaymentSettings(
        preparePaymentSettingsParams(params),
        fillWithDefaults ? { fillWithDefaults } : undefined
      ),
  });

  return query;
};
